import type { RequestSpec } from '@/types';

export function generateNodeAxios(url: string, spec: RequestSpec, hasAuth: boolean): string {
  const headers: string[] = [];
  if (hasAuth) headers.push(`    'Authorization': \`Bearer \${ACCESS_TOKEN}\``);
  headers.push(`    'Accept': 'application/json'`);
  if (spec.body !== undefined && spec.method !== 'GET' && spec.method !== 'DELETE') {
    headers.push(`    'Content-Type': 'application/json'`);
  }

  const dataLine =
    spec.body !== undefined && spec.method !== 'GET' && spec.method !== 'DELETE'
      ? `\n  data: ${JSON.stringify(spec.body, null, 2).replace(/\n/g, '\n  ')},`
      : '';

  return `import axios from 'axios';

const ACCESS_TOKEN = process.env.LIBERTIFY_TOKEN;

const { data } = await axios({
  method: '${spec.method.toLowerCase()}',
  url: '${url}',
  headers: {
${headers.join(',\n')},
  },${dataLine}
});
console.log(data);`;
}
